import type { Facture, FactureImprimable, Meta, Paiement, ParticipantDetail, ParticipantResume, PatchReglages, Tableau } from '../types';

const API_BASE = '/api';

// LE seul endroit où fetch est appelé (hors kit d'auth). Les composants importent `api`.
async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: 'La requête a échoué' }));
    throw new Error(body.error || 'La requête a échoué');
  }
  return res.json();
}

const json = (method: string, body: unknown): RequestInit => ({ method, body: JSON.stringify(body) });

export const api = {
  getMeta: () => request<Meta>('/meta'),
  updateReglagesGlobaux: (patch: Record<string, string | number>) => request<Record<string, string>>('/meta/reglages', json('PUT', patch)),

  getTableau: () => request<Tableau>('/tableau'),

  getParticipants: (termines: boolean) => request<ParticipantResume[]>(`/participants${termines ? '?termines=1' : ''}`),
  getParticipant: (id: number) => request<ParticipantDetail>(`/participants/${id}`),
  updateReglages: (id: number, patch: PatchReglages) => request(`/participants/${id}/reglages`, json('PUT', patch)),
  addPaiement: (id: number, data: { date: string; montant: number; moyen: string; note: string }) => request<Paiement>(`/participants/${id}/paiements`, json('POST', data)),
  deletePaiement: (id: number) => request(`/paiements/${id}`, { method: 'DELETE' }),
  addExclusion: (id: number, attendance_id: number, motif: string) => request(`/participants/${id}/exclusions`, json('POST', { attendance_id, motif })),
  removeExclusion: (id: number, attendance_id: number) => request(`/participants/${id}/exclusions/${attendance_id}`, { method: 'DELETE' }),
  createFacture: (id: number, data: { du: string; au: string; note: string }) => request<Facture>(`/participants/${id}/factures`, json('POST', data)),

  getFactures: (statut?: string) => request<Facture[]>(`/factures${statut ? `?statut=${statut}` : ''}`),
  getFacture: (id: number) => request<FactureImprimable>(`/factures/${id}`),
  updateFacture: (id: number, patch: { statut?: string; payee_le?: string | null; emise_le?: string | null; note?: string }) => request<Facture>(`/factures/${id}`, json('PUT', patch)),

  // Exports : liens directs (téléchargement navigateur)
  lienExportLedger: (id: number) => `${API_BASE}/participants/${id}/export.csv`,
  lienExportPaiements: (du: string, au: string) => `${API_BASE}/paiements/export.csv?du=${du}&au=${au}`,
};
